'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { captureReferralStorage } from '@/lib/referral/storage';

export default function ReferralCapture({ serverCode }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    try {
      captureReferralStorage(window.localStorage, { serverCode, queryCode: searchParams.get('ref') });
    } catch {
      // Accessing localStorage itself can throw in restricted browsers.
    }
  }, [serverCode, pathname, searchParams]);

  return null;
}
